import { gql } from "@apollo/client";


export const GET_CAMPAIGN_SCRIPT_DROPLIST = gql`
query GetCampaignScript {
  getCampaignScript {
    businessType
    departments
    outReachMethods
    reachOut
    sellTo
    sellType
  }
}
`

export const GET_ALL_CAMPAIGN = gql`
query GetAllCampaign {
  getAllCampaign {
  _id
  campaignName
  campaignType  
  campaignStarted
	campaignStatus
  sequence {
      _id
      message
      order
      seqType
      subject
      waitFor
    }
  }
}
`

export const GET_EDITOR_OUTBOUND_FIELDS = gql`
query GetEditorOutboundFields($campaignId: String!) {
  getEditorOutboundFields(campaignId: $campaignId) {
    fieldName
    fieldValue
    type
  }
}
`


export const GET_SEQUENCE_THREAD = gql`
query GetSequenceSubjects($campaignId: String!) {
  getSequenceSubjects(campaignId: $campaignId) {
    subject
  }
}
`
